import { Dtos, SuretyBondId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useRequest } from "../../../utils/request";
import { bondPreviewsQueryKey } from "../bond.keys";

export const useImportBond = () => {
	const { post } = useRequest();
	const [importedBondId, setImportedBondId] = useState<SuretyBondId | undefined>(undefined);
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["importBond"],
		mutationFn: async ({
			data,
			file,
		}: {
			data: Dtos.Admin.SuretyBond.Import.Request;
			file: File;
		}) => {
			const formData = new FormData();
			formData.append("file", file);
			formData.append("data", JSON.stringify(data));
			const bondId = (await post<SuretyBondId>(
				`/v2/admin/surety/bonds/import`,
				formData,
				"text",
			)) as SuretyBondId;
			setImportedBondId(bondId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondPreviewsQueryKey() });
		},
	});

	return { importBond: mutation.mutate, importBondLoading: mutation.isPending, importedBondId };
};
